import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ReportService } from '../service/report.service';
import { SidePanelService } from 'src/app/shared/services/side-pannel/side-pannel.service';
import { Router } from '@angular/router';
import { AdvancedSearchService } from 'src/app/shared/advanced-search/advanced-search.service';
import { AdvancedFilterService } from 'src/app/shared/advanced-filter/advanced-filter.service';
import { HomeService } from 'src/app/shared/services/home.service';

@Component({
  selector: 'app-all-file-list',
  templateUrl: './all-file-list.component.html',
  styleUrls: ['./all-file-list.component.scss']
})
export class AllFileListComponent implements OnInit, OnDestroy {
  public scrollDistance = 1;
  public throttle = 10;
  public page = 1;
  // public page_size = 20;
  // public totalFilePage = 2;

  // Currently applied advanced filter payload (keyed by filter.key)
  public appliedFilters: { [key: string]: any } = {};
  // Currently applied advanced search rows
  public appliedSearch: any[] = [];

  // Controlled state for the header Select-All checkbox.
  public selectAllChecked: boolean = false;

  private filterSub?: Subscription;
  private searchSub?: Subscription;

  constructor(
    public reportService:ReportService,
    private sidePanelService:SidePanelService,
    public aSearchservice:AdvancedSearchService,
    public aFilterService: AdvancedFilterService,
    private homeService: HomeService,
    public router: Router
  ) {
    // Hide the sub-sidenav on this page - mirrors RepositoryComponent's behavior
    // so navigating between the two views keeps the layout consistent.
    this.homeService.sidenav2Open.next(false);
  }

  ngOnInit(): void {
    this.reportService.isRepoSearch = false;
    this.aFilterService.getAllFileAdvanceFilter();
    // this.aFilterService.getAdvanceFilter1();
    this.reportService.allSelectedFiles = [];
    // Listen for advanced filter apply
    this.filterSub = this.aFilterService.applyFilterEmitter.subscribe((payload: any) => {
      this.appliedFilters = payload || {};
      this.page = 1;
      this.fetchFiles();
    });

    // Listen for advanced search apply
    this.searchSub = this.aSearchservice.applySearchEmitter.subscribe((payload: any[]) => {
      this.appliedSearch = payload || [];
      this.page = 1;
      this.fetchFiles();
    });

    this.fetchFiles();
    this.reportService.getAllStudyForDropdown();
  }

  ngOnDestroy(): void {
    this.filterSub?.unsubscribe();
    this.searchSub?.unsubscribe();
    this.aSearchservice.resetSearch(true);
    this.reportService.allSelectedFiles = [];
  }

  /**
   * Build the pagination payload including applied advanced filter/search state
   * and delegate to the report service.
   */
  private fetchFiles() {
    const payload: any = { page: this.page };
    if (this.appliedFilters && Object.keys(this.appliedFilters).length) {
      payload.applied_filters = this.appliedFilters;
    }
    if (this.appliedSearch && this.appliedSearch.length) {
      payload.advance_search = this.appliedSearch;
    }
    // Any refresh (page reset or next page) invalidates the "all selected"
    // state - user must re-select the newly loaded items explicitly.
    this.selectAllChecked = false;
    // if (this.page === 1) {
    //   // New dataset: previously selected rows no longer make sense.
    //   // this.reportService.allSelectedFiles = [];
    // }
    this.reportService.getAllRepositoryFilesPagination(payload);
  }

  onScroll(){
    if (!this.reportService.isScroleComleted) {
      this.page++;
      this.fetchFiles();
    }
  }
  

  openFilter(){
    // Reopen with previously applied filter state so values auto-fill.
    // If nothing was applied yet, service preserves its own working state.
    this.aFilterService.openFilter();
  }
  openAdvancedSearch(){
    // Reopen preserving previously applied search rows for auto-fill.
    this.aSearchservice.openSearch(
      this.appliedSearch && this.appliedSearch.length ? this.appliedSearch : undefined
    );
  }
  openMove(){
    // console.log("open move ====> ",this.reportService.allSelectedFiles);
    if(this.reportService.allSelectedFiles && this.reportService.allSelectedFiles.length > 0){
      this.reportService.isMoveAllFileOpen = true;
    }
  }

  openFile(file:any){
    this.reportService.viewFile(file,null,{previousRoute: '/repo/all-files'});
  }
 

  /**
   * Stable identifier for a file row - falls back across possible id fields.
   */
  private rowKey(data: any): any {
    if (!data) { return undefined; }
    return data.file_uuid !== undefined ? data.file_uuid
         : data.id !== undefined ? data.id
         : data;
  }

  /**
   * Whether the given file is currently in the selected list. Used to bind
   * the row checkbox so selection survives infinite-scroll re-renders.
   */
  isSelected(data: any): boolean {
    const key = this.rowKey(data);
    return this.reportService.allSelectedFiles.some(
      (item: any) => this.rowKey(item) === key
    );
  }

  selectRow(event:any, data:any){
    const key = this.rowKey(data);
    // console.log("selectRow ===> ", key);
    if(event.target.checked){
      if (!this.isSelected(data)) {
        this.reportService.allSelectedFiles.push(data);
      }
      // If manual selection now covers every loaded file, reflect that on the
      // header checkbox.
      this.selectAllChecked =
        this.reportService.allRepoFiles.length > 0 &&
        this.reportService.allSelectedFiles.length >= this.reportService.allRepoFiles.length;
    }else{
      const index = this.reportService.allSelectedFiles.findIndex(
        (item:any) => this.rowKey(item) === key
      );
      if(index > -1){
        this.reportService.allSelectedFiles.splice(index, 1);
      }
      this.selectAllChecked = false;
    }
  }

  selectAll(event:any){
    if(event.target.checked){
      this.reportService.allSelectedFiles = [...this.reportService.allRepoFiles];
      this.selectAllChecked = true;
    }else{
      this.reportService.allSelectedFiles = [];
      this.selectAllChecked = false;
    }
  }

  
}
